import Vue from 'vue'
const parser = require('ua-parser-js')

function setAuthenticityToken() {
  return document.querySelector("meta[name='csrf-token']").getAttribute('content')
}

export default function errorHandler() {
  Vue.config.errorHandler = function(err, vm, info) {
    let client = new parser().getResult()
    let authenticity_token = setAuthenticityToken()
    let url = window.location.href

    if (client) {
      client = JSON.stringify(client)
    }

    let params = {
      authenticity_token,
      error: {
        backtrace: err.stack,
        url,
        client
      }
    }

    Vue.http.post('/api/v1/errors', params).then(data => {
      console.error(err)
    })
  }
}
